module.exports = __webpack_public_path__ + "static/img/2.1bad337.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/2.png
// module id = 6990
// module chunks = 0